<form
  [formGroup]="loginForm"
  (ngSubmit)="onSubmit()"
  class="flex flex-col items-center justify-center gap-6 w-full max-w-lg p-6"
>
  <div class="field w-full">
    <p-iftalabel class="w-full">
      <input
        pInputText
        id="username"
        formControlName="username"
        autocomplete="off"
        class="w-full"
      />
      <label for="username">Użytkownik</label>
      @if (loginForm.controls.username.invalid && loginForm.controls.username.touched) {
        <small class="text-red-700">Podaj poprawny email.</small>
      }
    </p-iftalabel>
  </div>
  <div class="field w-full flex items-center">
    <p-iftalabel class="w-full">
      <input
        type="password"
        pInputText
        id="password"
        formControlName="password"
        autocomplete="off"
        class="w-full"
      />
      <label for="password">Hasło</label>
      @if (loginForm.controls.password.invalid && loginForm.controls.password.touched) {
        <small class="text-red-700">Hasło jest wymagane.</small>
      }
    </p-iftalabel>
  </div>

  <button pButton type="submit" [disabled]="loginForm.invalid || isLoaded">
    <ng-container *ngIf="!isLoaded; else loadingTpl">Zaloguj się</ng-container>

    <ng-template #loadingTpl>
      <i class="pi pi-spin pi-spinner"></i>
      Logowanie...
    </ng-template>
  </button>
</form>
